import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { fireCampaignUtmViewed } from '~/posthogs/events/Campaigns';
import { setCampaignAttribution } from '~/utils/posthog/campaignAttribution';
import { extractUtmParams } from '~/utils/posthog/extractUtmParams';

/**
 * Fires the UTM-viewed event and writes campaign person properties whenever the
 * portal is opened via a link carrying a campaign. Fires on every qualifying
 * landing (including repeat clicks of the same campaign) so re-engagement is
 * captured and last-touch (`latest_*`) stays accurate; first-touch (`initial_*`)
 * is held fixed by `$set_once`.
 */
export const useCampaignTracker = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = extractUtmParams(search);

    if (!params) {
      return;
    }

    const { source, campaign, medium, content, term } = params;

    fireCampaignUtmViewed({ source, campaign, medium, content, term });
    // Write first-touch ($set_once) / last-touch ($set) person properties so
    // the office is tied to the campaign, not just an anonymous event.
    setCampaignAttribution(params);
  }, [search]);
};
